module.exports = __webpack_public_path__ + "assets/platform-avatar2.f3ad94a3.svg";